import React from 'react'
import PropTypes from 'prop-types'
import { ParagraphDescription, DescriptionItem } from './styles'

export const Description = ({ textLeft, useBullets, description, descriptionList }) => (
  <>
    {useBullets ? (
      <ul>
        {descriptionList.map((item, index) => (
          <DescriptionItem key={index} textLeft={textLeft}>
            {item.descriptionItem}
          </DescriptionItem>
        ))}
      </ul>
    ) : (
      <ParagraphDescription textLeft={textLeft}>{description}</ParagraphDescription>
    )}
  </>
)

Description.propTypes = {
  textLeft: PropTypes.bool,
  useBullets: PropTypes.bool,
  description: PropTypes.string,
  descriptionList: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}
